/* eslint-disable import/no-named-as-default */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { Drawer, Grid, IconButton, Typography } from "@material-ui/core";
import { Close, ArrowBack } from "@material-ui/icons";
import { ButtonText, InputText } from "@loanbossinc/component-library";

import { getAccountingIntegrationsForDeal as getAccountingIntegrationsForDealActionCreator } from "../../../store/state/accountingIntegration";

import { actionCreators } from "./lenderReportingDrawer.store";
import { actionCreators as newLineItemActionCreators } from "./line-item-management/lineItemManagement.store";
import { actionCreators as rentRollFieldActionCreators } from "./field-management/rent-roll-field/rentRollField.store";
import { actionCreators as fieldManagementActionCreators } from "./field-management/fieldManagement.store";
import { actionCreators as sourceFileManagementActionCreators } from "./source-file-management/sourceFileManagement.store";
import { Header, PaddedWrapper, Title } from "./styles";
import FieldManagement from "./field-management";
import SourceFileManagement from "./source-file-management";
import LineItemManagement from "./line-item-management/lineItemManagement";
import InsertNewLineButton from "./line-item-management/insertNewLineButton";
import FormulaFields from "./line-item-management/formulaFields/FormulaFields";
import DscrManagement from "./dscr-line-items-management";
import AddDscrLineItemButton from "./dscr-line-items-management/addDscrLineItemButton";
import DebtYieldManagement from "./debt-yield-line-items-management/index";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";

const LenderReportingDrawer = props => {
  const {
    allDealLoans,
    authentication,
    closeDrawer,
    currentSection,
    deal,
    initialDrawerSectionName = null,
    isFromLineItemManagement,
    isEditingLineItem,
    isOpen,
    drawerMinWidth,
    isDeleteDialogOpen,
    setDrawerSelections,
    setNewLineItemSelections,
    setRentRollSelectionsToDefault,
    setRentRollFieldSelections,
    isChoosingForAccountingIntegration,
    onChooseForAccountingIntegration,
    accountingIntegrations,
    getAccountingIntegrationsForDeal,
    propertyId,
    wasRentRollFieldUpdated,
    wasNoiDashboardUpdated,
    deleteFieldsConfig,
    getFieldsForDeletion,
    fieldsForDeletion,
    fieldIdsToDelete,
    deleteSourceFiles,
    deleteSourceFilesByDeal,
    setSourceFileManagementSelections,
    getSourceFilesByDeal
  } = props;

  const [deleteFormInput, setDeleteFormInput] = useState("");
  const [sourceFilesToDelete, setSourceFilesToDelete] = useState(null);

  useEffect(() => {
    if (deal?.id && !accountingIntegrations) {
      getAccountingIntegrationsForDeal(deal.id);
    }
  }, [deal, getAccountingIntegrationsForDeal, accountingIntegrations]);

  useEffect(() => {
    if (!isOpen) {
      setRentRollSelectionsToDefault();
    }
  }, [isOpen]);

  const updateFieldsList = () => {
    getFieldsForDeletion({ dealId: deal.id });
  };

  const resetFieldsList = () => {
    setDrawerSelections({ fieldIdsToDelete: null});
  };

  useEffect(() => {
    setDrawerSelections({ currentSectionName: initialDrawerSectionName });
  }, [initialDrawerSectionName]);

  useEffect(() => {
    if (deal && !fieldIdsToDelete && isOpen) {
      getFieldsForDeletion({ dealId: deal.id });
    }
    if(!isOpen) {
      resetFieldsList();
    }
  }, [deal, fieldIdsToDelete, isOpen]);

  useEffect(() => {
    if(fieldsForDeletion) {
      const fieldIds = [];
      fieldsForDeletion.forEach(field => fieldIds.push(field.id));
      if(fieldIds.length > 0) {
        setDrawerSelections({ fieldIdsToDelete: fieldIds});
      }
    }
  },[fieldsForDeletion]);

  const changeSection = () => {
    if (wasRentRollFieldUpdated) {
      setRentRollFieldSelections({ showConfirmationModal: true, locationModalIsOpenFrom: "go_to_source_files" });
    } else {
      setDrawerSelections({ currentSectionName: currentSection && currentSection.goToButtonValue });
    }
  };

  const goBackToLineItems = () => {
    setDrawerSelections({ currentSectionName: "line-item-management" });
    setNewLineItemSelections({ isSelectingForFirstField: null });
  };

  const onBeforeClose = () => {
    if (wasRentRollFieldUpdated) {
      setRentRollFieldSelections({ showConfirmationModal: true });
    } else {
      closeDrawer();
    }
  };

  const isLineItemManagement =
    Boolean(currentSection) &&
    (currentSection.name === "line-item-management" ||
      currentSection.name === "comparison-field-selection" ||
      currentSection.name === "debt-yield-line-items" ||
      currentSection.name === "dscr-line-items" ||
      currentSection.name === "dscr-from-file");

  const handleDeleteConfirm = () => {
    if (deleteFormInput === "DELETE") {
      if (currentSection.name === "field-management") {
        deleteFieldsConfig({ dealId: deal.id, fieldIds: fieldIdsToDelete });
      }
      if (currentSection.name === "source-file-management") {
        if(sourceFilesToDelete) {
          deleteSourceFiles({ dealId: deal.id, sourceFileIds: sourceFilesToDelete });
          setSourceFileManagementSelections({ selectedSourceFile: null, selectedSourceFileVersions: null });
          getSourceFilesByDeal({ dealId: deal.id });
        } else {
          deleteSourceFilesByDeal({ dealId: deal.id });
        }
      }
      setDrawerSelections({ isDeleteDialogOpen: false });
      setDeleteFormInput("");
    }
  };

  return (
    <Drawer onClose={onBeforeClose} anchor="right" open={isOpen} PaperProps={{ style: { minWidth: drawerMinWidth, display: "unset" } }}>
      <Header isLineItem={isLineItemManagement}>
        <Grid container justify="flex-start" alignItems="center" direction="row">
          <div>
            <PaddedWrapper>
              {Boolean(currentSection) && currentSection.name === "comparison-field-selection" ? (
                <IconButton onClick={goBackToLineItems}>
                  <ArrowBack />
                </IconButton>
              ) : (
                <IconButton onClick={onBeforeClose}>
                  <Close style={{ color: "#C40A0A" }} />
                </IconButton>
              )}
            </PaddedWrapper>
          </div>
          <div style={{ flexGrow: 1 }}>
            <PaddedWrapper>
             <Title>{(Boolean(currentSection) && currentSection.title) || "Lender Reporting"}</Title>
              <Typography
                onClick={() => setDrawerSelections({ isDeleteDialogOpen: true })}
                style={{ color: "#C40A0A", fontFamily: "work sans", fontSize: "14px", cursor: "pointer" }}
              >
                {Boolean(currentSection) && authentication.isSystemAdmin && !isEditingLineItem && (currentSection.deleteText)}
            </Typography>
            </PaddedWrapper>
          </div>
          <div>
            <PaddedWrapper>
              {Boolean(currentSection) && currentSection.name !== "line-item-management" && currentSection.name !== "dscr-line-items" && (
                <ButtonText
                  onClick={changeSection}
                  label={Boolean(currentSection) && currentSection.goToButtonText}
                  alignRight
                  style={{ width: "100%", paddingRight: "1.25em", display: isFromLineItemManagement ? "none" : "" }}
                />
              )}
              {Boolean(currentSection) && currentSection.name === "line-item-management" && (
                <Grid container justify="flex-end">
                  <Grid item>
                    <InsertNewLineButton />
                  </Grid>
                </Grid>
              )}
              {Boolean(currentSection) && currentSection.name === "dscr-line-items" && (
                <Grid container justify="flex-end">
                  <Grid item>
                    <AddDscrLineItemButton />
                  </Grid>
                </Grid>
              )}
            </PaddedWrapper>
          </div>
        </Grid>
      </Header>
      {Boolean(currentSection) && currentSection.name === "field-management" && (
        <FieldManagement
          isOpen={isOpen}
          deal={deal}
          allDealLoans={allDealLoans}
          isChoosingForAccountingIntegration={isChoosingForAccountingIntegration}
          onChooseForAccountingIntegration={onChooseForAccountingIntegration}
          accountingIntegrations={accountingIntegrations}
          propertyId={propertyId}
          updateFieldsList={updateFieldsList}
          resetFieldsList={resetFieldsList}
          wasNoiDashboardUpdated={wasNoiDashboardUpdated}
        />
      )}
      {Boolean(currentSection) && currentSection.name === "source-file-management" && (
        <SourceFileManagement isOpen={isOpen} deal={deal} setSourceFilesToDelete={setSourceFilesToDelete} />
      )}
      {Boolean(currentSection) && currentSection.name === "line-item-management" && (
        <LineItemManagement isOpen={isOpen} deal={deal} accountingIntegrations={accountingIntegrations} />
      )}
      {Boolean(currentSection) && currentSection.name === "comparison-field-selection" && (
        <FormulaFields isOpen={isOpen} deal={deal} accountingIntegrations={accountingIntegrations} />
      )}
      {Boolean(currentSection) && currentSection.name === "dscr-line-items" && <DscrManagement isOpen={isOpen} />}
      {Boolean(currentSection) && currentSection.name === "debt-yield-line-items" && (
        <DebtYieldManagement isOpen={isOpen} deal={deal} isFromFile accountingIntegrations={accountingIntegrations} />
      )}
      <SimpleConfirmDialog
        modalOpen={isDeleteDialogOpen}
        title={Boolean(currentSection) && currentSection.deleteText}
        message={Boolean(currentSection) && currentSection.deleteHelperText}
        secondaryContent={
          <div>
            <p>
              <InputText
                name="reportDeleteConfirm"
                label={"Confirm by typing \"DELETE\""}
                value={deleteFormInput}
                onChange={e => {
                  setDeleteFormInput(e.target.value);
                }}
                style={{ width: "100%" }}
              />
            </p>
          </div>
        }
        yesText="Ok"
        noText="Cancel"
        handleNo={() => {
          setDeleteFormInput("");
          setDrawerSelections({ isDeleteDialogOpen: false });
        }}
        handleYes={handleDeleteConfirm}
      />
    </Drawer>
  );
};

const mapStateToProps = ({ authentication, lenderReportingDrawer, accountingIntegration, lenderReportRentRollField: { isAnythingWasUpdated } }) => ({
  ...lenderReportingDrawer,
  authentication,
  accountingIntegrations: accountingIntegration.dealItems,
  wasRentRollFieldUpdated: isAnythingWasUpdated
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    ...actionCreators,
    ...newLineItemActionCreators,
    ...rentRollFieldActionCreators,
    ...fieldManagementActionCreators,
    ...sourceFileManagementActionCreators,
    getAccountingIntegrationsForDeal: getAccountingIntegrationsForDealActionCreator
  },
  dispatch
);

export default compose(connect(mapStateToProps, mapDispatchToProps))(LenderReportingDrawer);
